import { FC, memo } from "react"

import { Provider } from "../../context"
import { DropdownPropsWithChildren, DropdownStaticProps } from "../../types"
import { Option } from "../option"

import { DropdownComponent } from "./dropdown"

// Cast type to any so we can assign static properties later
const Container: any = memo<DropdownPropsWithChildren>((props) => (
  <Provider dropdownProps={props}>
    <DropdownComponent />
  </Provider>
))

/**
 * @deprecated
 * Dropdown component is deprecated. Please use the new Select component instead.
 * You can find more documentation here: https://design.zettletest.com/components/web/select
 * This component will be removed on the 1st of May, 2023.
 */
export const Dropdown: FC<DropdownPropsWithChildren> & DropdownStaticProps = Container

Dropdown.Option = Option
